import { BASE_URL } from "../constants";
import axios_ from "axios";

const axios = axios_.create({
  baseURL: BASE_URL,
  // withCredentials: true,
});

export default axios;
